import { SVGProps } from 'react';

export function HumanPartyFace(props: SVGProps<SVGSVGElement>) {
  return (
    <svg id="emoji" viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" data-testid="human-party-face" {...props}>
      <g id="color">
        <circle cx="36" cy="36" r="23" fill="#FCEA2B" />
        <polygon fill="#F4AA41" points="15.0628,6.4465 17.0628,21.4465 33.0628,15.4465" />
        <polyline fill="#E27022" points="26.9838,12.4065 33.0628,15.4465 19.9118,20.3785" />
        <polygon fill="#EA5A47" points="15.3958,10.8345 20.6208,8.8175 23.4538,10.5795 15.5628,13.9465" />
        <polyline fill="#D22F27" points="25.4208,12.3925 26.5628,11.9465 30.5628,12.9465 24.0628,15.7315" />
        <polyline fill="#EA5A47" points="24.0628,15.7315 16.5588,18.9465 16.3958,15.9125 25.4208,12.3925" />
      </g>
      <g id="line">
        <g>
          <g id="line-2">
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M36.4495,42.1182 c0,0,10.5509,3.1081,0.0462,5.5636c0,0,10.4821,2.9013,0.0408,4.9123"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21.0196,27.355 c0.7084-1.3911,1.9076-2.4701,3.3656-3.028c1.3992-0.711,3.0133-0.8745,4.5266-0.4585"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M50.6289,27.1092 c-1.6054-2.7593-4.838-4.1297-7.9374-3.3648"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M23.4538,34.3787 c2.5075-1.2805,5.4716-1.3051,8-0.0664"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M40.7028,34.2355 c2.5075-1.2805,5.4716-1.3051,8-0.0665"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M45.9475,15.294 c11.4492,5.5027,16.2698,19.2449,10.7671,30.694s-19.2449,16.2698-30.694,10.7671S9.7508,37.5103,15.2535,26.0611 c0.3849-0.8008,0.8159-1.5787,1.2907-2.3296"
            />
            <path
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M34.9564,13.0521 c0.2775-0.0123,0.5563-0.0196,0.8362-0.0219c3.5138-0.0343,6.9884,0.7403,10.1549,2.2638"
            />
          </g>
          <g>
            <line
              x1="17.3843"
              x2="14.5628"
              y1="20.9801"
              y2="5.9801"
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              x1="33.5628"
              x2="14.5628"
              y1="15.2458"
              y2="5.9801"
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              x1="17.3843"
              x2="33.5628"
              y1="20.9801"
              y2="15.2458"
              fill="none"
              stroke="#000000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
          <path
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M61.9463,11.6129 c-0.0716,0.5158-0.2255,1.0168-0.4556,1.484c-1.2886,2.5208-4.3362,3.5763-6.9079,2.3925"
          />
          <path
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M66.4265,43.3491 c-0.5082-0.1136-0.995-0.3079-1.4418-0.5754c-2.4074-1.4903-3.2103-4.6144-1.82-7.0809"
          />
          <path
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M61.9463,62.9681 c-0.0716-0.5158-0.2255-1.0168-0.4556-1.484c-1.2886-2.5208-4.3362-3.5763-6.9079-2.3925"
          />
          <path
            fill="none"
            stroke="#000000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M24.7394,55.925 c-0.3282-0.4043-0.7191-0.7534-1.1578-1.0341c-2.4073-1.4907-5.562-0.8167-7.15,1.5276"
          />
          <path d="M62.2115,25.4594c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C60.7908,24.7995,61.4234,25.4321,62.2115,25.4594z" />
          <path d="M62.2115,50.4594c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C60.7908,49.7995,61.4234,50.4321,62.2115,50.4594z" />
          <path d="M29.2115,66.4594c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C27.7908,65.7995,28.4234,66.4321,29.2115,66.4594z" />
          <path d="M20.2115,48.4594c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C18.7908,47.7995,19.4234,48.4321,20.2115,48.4594z" />
          <path d="M44.2115,64.4594c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C42.7908,63.7995,43.4234,64.4321,44.2115,64.4594z" />
        </g>
        <path
          fill="none"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M38.5628,47.9801h5.5 c0,0,5.5,0,5.5-3c0-2.2319-1.5221-2.8033-3.4339-2.95"
        />
      </g>
      <g id="color-foreground">
        <path
          fill="#8967AA"
          d="M62.2115,25.457c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C60.7908,24.7971,61.4234,25.4297,62.2115,25.457z"
        />
        <path
          fill="#8967AA"
          d="M44.2115,64.457c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C42.7908,63.7971,43.4234,64.4297,44.2115,64.457z"
        />
        <path
          fill="#F4AA41"
          d="M29.2115,66.457c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C27.7908,65.7971,28.4234,66.4297,29.2115,66.457z"
        />
        <path
          fill="#D22F27"
          d="M20.2115,48.457c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C18.7908,47.7971,19.4234,48.4297,20.2115,48.457z"
        />
        <path
          fill="#D22F27"
          d="M62.2115,50.457c0.8284-0.0287,1.4767-0.7235,1.448-1.552c-0.0273-0.7881-0.6599-1.4207-1.448-1.448 c-0.8284,0.0287-1.4767,0.7235-1.448,1.552C60.7908,49.7971,61.4234,50.4297,62.2115,50.457z"
        />
      </g>
    </svg>
  );
}
